<script setup lang="ts">
/**
 * Group table cell: the room (`BookingType.address`) a dedicated-schedule
 * group books against — mirrors the sketch's `.g-room`. Null covers both
 * "not a dedicated-schedule group" and "dedicated but the booking type has
 * no address set"; both render the same "not set" placeholder.
 */
import { useI18n } from 'vue-i18n'

defineProps<{
  room?: string | null
  /** Max width of the cell (CSS value). Set by DynamicTable from column config. */
  maxWidth?: string
}>()

const { t } = useI18n()
</script>

<template>
  <td
    class="font-tufte-sans"
    :style="{
      fontSize: 'var(--text-tufte-xs)',
      ...(maxWidth ? { maxWidth, overflowWrap: 'break-word' } : {}),
    }"
  >
    <span v-if="room" class="text-tufte-text">{{ room }}</span>
    <span v-else class="group-room-cell__none text-tufte-muted">{{
      t('cards.group.roomNotSet')
    }}</span>
  </td>
</template>

<style scoped>
.group-room-cell__none {
  font-style: italic;
}
</style>
